import {
  BrowserCacheLocation,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';
import { getMsalEntraConfig } from './msal-config';

/**
 *
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  const config = getMsalEntraConfig();
  return new PublicClientApplication({
    auth: {
      clientId: config.clientId,
      authority: config.authorityUrl,
      redirectUri: config.redirectUri,
      knownAuthorities: config.authorityDomain,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
  });
}
